import React, { useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import { ButtonVariant } from "Constant/button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";

import useHostFooterAction from "components/organisms/CreationModal/hooks/useHostFooterAction";

import MouseOverPopover from "../../components/MouseOverPopover";
import "../../css/createSourceModal.css";
import { sendVtigerData } from "../../helpers/Sources/vtiger/vtiger";
import StandartButton from "../atoms/StandartButton";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import SwalAlertComp from "../SwalAlert";

const VtigerSource = (props) => {
    const { useHostFooter = false, registerFooterAction } = props;
    const [vtigerInput, setVtigerSaleInput] = useState({
        name: "",
        crm_username: "",
        crm_access_key: "",
        crm_url: "",
    });
    const [vtigerSourceID, setVtigerSourceID] = useState("");
    const [btnCheck, setBtnCheck] = useState(true);
    const [vtigerData, setVtigerData] = useState(null);
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [errorMessages, setErrorMessages] = useState({
        name: "",
        crm_username: "",
        crm_access_key: "",
        crm_url: "",
    });

    const language = useSelector((state) => state.languagesState.languages);

    const setLoadingState = (loading) => {
        setIsSaveLoading(loading);
        props?.setLoading?.(loading);
    };

    const handleCloseModal = () => {
        props?.handleClose?.();
        setBtnCheck(false);
    };

    const popoverVtiger = (
        <div>
            <strong className="d-block">How to Get Access Key?</strong>
            After completing the recaptcha step under the API Authentication
            section, you can obtain your API Key and Bundle Alias codes.
        </div>
    );

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setVtigerSaleInput({ ...vtigerInput, [name]: value });
        setErrorMessages({
            ...errorMessages,
            [name]: value ? "" : "Cannot be blank!",
        });
    };

    const fetchVtigerData = async () => {
        if (
            !vtigerInput.name ||
            !vtigerInput.crm_username ||
            !vtigerInput.crm_access_key ||
            !vtigerInput.crm_url
        ) {
            setErrorMessages({
                name:
                    vtigerInput.name === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
                crm_username:
                    vtigerInput.crm_username === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
                crm_access_key:
                    vtigerInput.crm_access_key === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
                crm_url:
                    vtigerInput.crm_url === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
            });
        } else {
            setLoadingState(true);
            let data = {
                name: vtigerInput?.name,
                crm_username: vtigerInput?.crm_username,
                crm_access_key: vtigerInput?.crm_access_key,
                crm_url: vtigerInput?.crm_url,
                usage_types: [4],
            };
            let response = await sendVtigerData(data);
            if (response.status) {
                setVtigerData(response?.data?.field_data?.fields);
                if (props.selectFileSourceId) {
                    props.selectFileSourceId(
                        response?.data?.source?.id,
                        response?.data?.source?.source_type_id,
                    );
                }
                setBtnCheck(false);
                setVtigerSourceID(response?.data?.source?.id);
                setLoadingState(false);
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response?.message ?? "",
                    icon: "error",
                });
                setLoadingState(false);
            }
        }
    };

    const saveCrmMapping = (response) => {
        props?.setIsMappingSuccessfull?.(true);
        setLoadingState(true);
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            props?.handleClose(vtigerSourceID);
            if (props.handleGetSources) {
                props.handleGetSources();
            }
            if (props.getTracker) {
                props.addToTracker(vtigerSourceID);
            }
            if (props.getAllSourcesReduxProps) {
                props.getAllSourcesReduxProps();
            }
            if (props.setNextCheck) {
                props.setNextCheck(true);
            }
            setVtigerSourceID("");
            setBtnCheck(false);
            setLoadingState(false);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            setLoadingState(false);
        }
    };

    useHostFooterAction(registerFooterAction, "form", {
        label: language?.buttons?.continue ?? "Continue",
        onSubmit: fetchVtigerData,
        isLoading: isSaveLoading,
        hidden: !!vtigerData,
    });

    const saveButton = (
        <StandartButton
            variant="contained"
            color="primary"
            onClick={fetchVtigerData}
            isLoading={isSaveLoading}
            disabled={isSaveLoading}
            wrapperSx={{ marginLeft: "auto", width: "fit-content" }}
        >
            {language?.buttons?.create_source ?? "Create Source"}
        </StandartButton>
    );

    return (
        <div>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                {vtigerData ? (
                    <>
                        <CrmSourceMappingArea
                            sourceId={vtigerSourceID}
                            sourceType={"vtiger"}
                            mappingSuccess={saveCrmMapping}
                            isModal={props?.isModal}
                            hideSaveButton={useHostFooter}
                            registerFooterAction={registerFooterAction}
                        ></CrmSourceMappingArea>
                    </>
                ) : (
                    <>
                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.name === null}
                        >
                            <TextField
                                name="name"
                                label={language?.source_modal?.name ?? "Name"}
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.please_write_name ??
                                    "Please Write Name"
                                }
                                value={vtigerInput?.name}
                                required
                                error={errorMessages.name === null}
                            />
                            {errorMessages?.name && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.name}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.crm_username === null}
                        >
                            <TextField
                                name="crm_username"
                                label={
                                    language?.source_modal?.username ??
                                    "Username"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal
                                        ?.please_write_username ??
                                    "Please Write Username"
                                }
                                value={vtigerInput?.crm_username}
                                required
                                error={errorMessages.crm_username === null}
                            />
                            {errorMessages?.crm_username && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.crm_username}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3 mouse-over-popover-area"
                            style={{ width: "100%" }}
                            error={errorMessages.crm_access_key === null}
                        >
                            <TextField
                                name="crm_access_key"
                                label={
                                    language?.source_modal?.access_key ??
                                    "Access Key"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal
                                        ?.please_write_access_key ??
                                    "Please Write Access Key"
                                }
                                value={vtigerInput?.crm_access_key}
                                required
                                error={errorMessages.crm_access_key === null}
                            />
                            {errorMessages?.crm_access_key && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.crm_access_key}
                                </div>
                            )}
                            <MouseOverPopover
                                text={popoverVtiger}
                            ></MouseOverPopover>
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.crm_url === null}
                        >
                            <TextField
                                name="crm_url"
                                label={language?.source_modal?.url ?? "URL"}
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.please_write_url ??
                                    "Please Write URL"
                                }
                                value={vtigerInput?.crm_url}
                                required
                                error={errorMessages.crm_url === null}
                            />
                            {errorMessages?.crm_url && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.crm_url}
                                </div>
                            )}
                        </FormControl>
                    </>
                )}
            </Form.Group>

            {!useHostFooter &&
                btnCheck &&
                (props?.isModal ? (
                    <Modal.Footer className="source-modal-footer">
                        <StandartButton
                            variant={ButtonVariant.BLACK_OUTLINED}
                            onClick={handleCloseModal}
                            disabled={isSaveLoading}
                        >
                            {language?.buttons?.close ?? "Close"}
                        </StandartButton>
                        {saveButton}
                    </Modal.Footer>
                ) : (
                    saveButton
                ))}
        </div>
    );
};

export default VtigerSource;
